import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LogoSlider = () => {
  const { t } = useLanguage();
  
  const customers = [
    { name: "BLAC_SALT/24",     logo: "/partners/blac_salt_24.png",   url: "https://blacsalt.au/" },
    { name: "BLAC_SALT/25",     logo: "/partners/blac_salt_25.png",   url: "https://blacsalt.au/" },
    { name: "BLAC_SALT/26",     logo: "/partners/blac_salt_26.png",   url: "https://blacsalt.au/" },
    { name: "Agents'Agency",    logo: "/partners/agents_agency.png",  url: "https://agentsagency.au" },
    { name: "Chania Beach Party", logo: "/partners/cbp.png",          url: "https://www.chaniabeachparty.com/" },
    { name: "Agefluid",         logo: "/partners/agefluid.png",       url: "https://agefluid.me/" },
    { name: "Southbreak Jam",   logo: "/partners/southbreak_jam.png", url: "https://dancedeets.com/battles/southbreak-jam-battle-2026" },
    { name: "Hood Groove",      logo: "/partners/hood_groove.png",    url: "https://www.hoodgroove.com/en/" },
  ];

  const doubledCustomers = [...customers, ...customers];

  return (
    <section className="py-6 bg-slate-50 border-b border-slate-100 overflow-hidden relative">
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes logoMarquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-logo-marquee {
          display: flex;
          width: max-content;
          animation: logoMarquee 35s linear infinite;
        }
        .animate-logo-marquee:hover {
          animation-play-state: paused;
        }
      `}} />
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-4">
          <p className="text-xs md:text-sm font-extrabold text-gradient tracking-widest uppercase select-none inline-block">
            {t('hero.logoSlider.title')}
          </p>
        </div>
        
        <div className="relative w-full overflow-hidden">
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-50 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-50 to-transparent z-10 pointer-events-none"></div>
          
          <div className="animate-logo-marquee gap-5 items-center py-2">
            {doubledCustomers.map((customer, index) => (
              <a
                key={`${customer.name}-${index}`}
                href={customer.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center p-[1.5px] rounded-2xl bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 hover:from-indigo-500 hover:via-purple-500 hover:to-pink-500 transition-all duration-500 shadow-sm hover:shadow-lg cursor-pointer select-none group flex-shrink-0"
              >
                <div className="bg-white rounded-[14px] px-5 py-3 flex items-center justify-center h-16 min-w-[160px] transition-colors duration-300">
                  <img
                    src={customer.logo}
                    alt={customer.name}
                    className="h-11 w-auto object-contain opacity-50 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-105"
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;
